// var BASE_URL = process.env.API_ROOT + "/api"
var BASE_URL = process.env.API_ROOT + "/v2"
var BASE_URL_VOC = process.env.API_VOC_ROOT + "/voc"
var BASE_URL_CONCIERGE = process.env.API_CONCIERGE_ROOT + "/v1"

// 마이페이지 API 이관 (admin_server /v2/concierge/mypage → concierge-admin /v1/app)
// 운영 서버 배포 전까지 env(USE_CONCIERGE_APP_API)로 전환
var USE_CONCIERGE_APP_API = process.env.USE_CONCIERGE_APP_API === true
var BASE_URL_ACCOUNT = USE_CONCIERGE_APP_API ? BASE_URL_CONCIERGE + "/app/account" : BASE_URL + "/concierge/mypage"
var BASE_URL_MYPAGE = USE_CONCIERGE_APP_API ? BASE_URL_CONCIERGE + "/app/mypage" : BASE_URL + "/concierge/mypage"
var BASE_URL_STORE = BASE_URL_CONCIERGE + "/app/store"

export default {
    TEMP_SAVE_DIABETES: BASE_URL + "/barocare/diabetes/temp/save/",
    FETCH_TEMP_SAVE_DIABETES: BASE_URL + "/barocare/diabetes/temp/",
    SAVE_FIRST_DIABETES: BASE_URL + "/barocare/diabetes/delegate/",
    SAVE_REVISIT_DIABETES: BASE_URL + "/barocare/diabetes/delegate/",
    CHECK_DIABETES_EXISTS: BASE_URL + "/barocare/diabetes/exists/",
    // mypage
    SIGNIN_DIABETES_USER: BASE_URL + "/barocare/diabetes/signin/",
    // SIGNIN_AGREEMENT: BASE_URL + "/barocare/diabetes/signin/agreement/",
    FETCH_DIABETES_USER_PROFILES: BASE_URL + "/barocare/diabetes/delegate/",
    UPDATE_DIABETES_USER_CARD: BASE_URL + "/barocare/diabetes/delegate/",
    SAVE_FILE: BASE_URL + "/diabetes/upload",
    UPDATE_DIABETES_USER_DELIVERY: BASE_URL + "/barocare/diabetes/delivery/${profile_id}/",
    // 서류
    FETCH_DIABETES_HISTORY: BASE_URL + "/barocare/diabetes/history/",
    FETCH_DIABETES_DOCUMENT: BASE_URL + "/barocare/diabetes/history/docs/",
    FETCH_DIABETES_SETTLEMENT: BASE_URL + "/barocare/diabetes/history/year-tax/",
    // home 
    // campaign
    FETCH_DIABETES_VOC_PAGE: BASE_URL_VOC + "/diabetes/page/${pNo}/${size}/${sort}",
    ADD_DIABETES_VOC: BASE_URL_VOC + "/diabetes",
    UPDATE_DIABETES_VOC: BASE_URL_VOC + "/diabetes",

    // v2
    USE_CONCIERGE_APP_API: USE_CONCIERGE_APP_API,
    SIGNIN_KAKAO: BASE_URL_ACCOUNT + "/signin/",
    SIGNIN_AGREEMENT: BASE_URL_ACCOUNT + "/signin/agreement/",

    FETCH_PROFILES: BASE_URL_MYPAGE + "/profiles/",
    FETCH_EXPECTED_DATE: BASE_URL_MYPAGE + "/profiles/expected-date/",

    // 처음 위임장 요청
    ADD_DRAFT_PROFILE: BASE_URL_MYPAGE + "/profiles/",
    SAVE_DELEGATE_WITH_ADDITION: BASE_URL_MYPAGE + "/profiles/${profile_id}/delegate-addition-info/",
    SAVE_CARD: BASE_URL_MYPAGE + "/profiles/${profile_id}/card/",
    REGISTER_PROFILE: BASE_URL_MYPAGE + "/profiles/${profile_id}/register/",

    // 환자정보
    FETCH_PROFILE: BASE_URL_MYPAGE + "/profiles/${profile_id}/",
    UPDATE_PROFILE: BASE_URL_MYPAGE + "/profiles/${profile_id}/",
    UPDATE_CARD: BASE_URL_MYPAGE + "/profiles/${profile_id}/card/",
    DELETE_CARD: BASE_URL_MYPAGE + "/profiles/${profile_id}/card/",
    UPDATE_DELIVERY: BASE_URL_MYPAGE + "/profiles/${profile_id}/address/",
    SAVE_DELEGATE: BASE_URL_MYPAGE + "/profiles/${profile_id}/delegate/",     // 위임 정보만 생성
    SAVE_DELEGATE_ADDTION: BASE_URL_MYPAGE + "/profiles/${profile_id}/addition-info/",  // 구매 조건 만 수정

    // 서류 정보
    FETCH_USAGE: BASE_URL_MYPAGE + "/usage/",
    FETCH_DOCUMENTS: BASE_URL_MYPAGE + "/usage/documents/",
    FETCH_YEAR_TAX: BASE_URL_MYPAGE + "/usage/year-tax/",

    // 친구 추천
    FETCH_INVITE_CODE: BASE_URL_CONCIERGE + "/app/account/referral/",
    APPLY_INVITE_CODE: BASE_URL_CONCIERGE + "/app/account/referral/",
    FETCH_INVITE_FRIENDS: BASE_URL_CONCIERGE + "/app/account/referral/friends/",

    // 컨시어지몰 (당뇨 제품 판매)
    FETCH_STORE_CATEGORIES: BASE_URL_STORE + "/categories/",
    FETCH_STORE_PRODUCTS: BASE_URL_STORE + "/products/",
    CALC_STORE_COST: BASE_URL_STORE + "/products/cost/",
    FETCH_CART: BASE_URL_STORE + "/cart/",
    UPDATE_CART_ITEMS: BASE_URL_STORE + "/cart/items/",
    FETCH_CART_FILE_PRESIGNED_URL: BASE_URL_STORE + "/cart/files/presigned-url/",
    ADD_CART_FILES: BASE_URL_STORE + "/cart/files/",
    DELETE_CART_FILE: BASE_URL_STORE + "/cart/files/${file_id}/",
    COPY_CART_FROM_ORDER: BASE_URL_STORE + "/cart/from-order/${reception_number}/",
    CHECKOUT_CART: BASE_URL_STORE + "/cart/checkout/",
    PAY_CART: BASE_URL_STORE + "/cart/pay/",
    FETCH_STORE_ORDERS: BASE_URL_STORE + "/orders/",
    FETCH_ORDER_STATEMENT: BASE_URL_STORE + "/orders/${reception_number}/statement/"
}



// WEBPACK FOOTER //
// ./src/Config.js